/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitProfileListByCompanyId,
    PressKitProfileListByCompanyIdFromJSON,
    PressKitProfileListByCompanyIdFromJSONTyped,
    PressKitProfileListByCompanyIdToJSON,
} from './PressKitProfileListByCompanyId';

/**
 * 
 * @export
 * @interface GetPressKitProfilesListResponse
 */
export interface GetPressKitProfilesListResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetPressKitProfilesListResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetPressKitProfilesListResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitProfileListByCompanyId}
     * @memberof GetPressKitProfilesListResponse
     */
    data: PressKitProfileListByCompanyId;
}

export function GetPressKitProfilesListResponseFromJSON(json: any): GetPressKitProfilesListResponse {
    return GetPressKitProfilesListResponseFromJSONTyped(json, false);
}

export function GetPressKitProfilesListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressKitProfilesListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitProfileListByCompanyIdFromJSON(json['data']),
    };
}

export function GetPressKitProfilesListResponseToJSON(value?: GetPressKitProfilesListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitProfileListByCompanyIdToJSON(value.data),
    };
}

